import React from 'react';
import './Home.css'; 
import banner from "../../img/flight-banner.jpg";
import flightIcon from "../../img/flight-icon.svg";
import Location from './Location';
// import Sponser from './Sponser';
// import Flight from './Flight';
// import Provider from './Provider';
// import PackageType from './PackageType';
// import Info from './Info';
import Marque from './Marque';
import Client from './Client';
// import Buisness from './Buisness';
import Article from './Article';
import Footer from './Footer';

const Home = () => {
  return (
    <>
    <div className="hero-section">
      <div className="hero-overlay">
        <img
          src={banner}
          alt="Hero Background"
          className="hero-image"
        />
      </div>
      <div className="hero-content">
      <h1>
  Discover the World, One 
  <span className="flight-icon-container">
    <img
      src={flightIcon}
      alt="Flight Icon"
      className="flight-icon"
    />
  </span>
  Flight at a Time with DreamsTour!
</h1>

        <p>
          Your ultimate destination for all things to help you celebrate & remember your tour experience.
        </p>
        {/* <div className="search-buttons">
          <button className="search-btn">Flights</button>
          <button className="search-btn">Hotels</button>
          <button className="search-btn">Cars</button>
          <button className="search-btn">Cruise</button>
          <button className="search-btn">Tour</button>
        </div> */}
      </div>
    </div>
    <Location/>
    {/* <Sponser/> */}
    {/* <Flight/> */}
    {/* <Provider/> */}
    {/* <PackageType/> */}
    {/* <Info/> */}
    <Marque/>
    <Client/>
    {/* <Buisness/> */}
    <Article/>
    <Footer/>
    </>
  );
};

export default Home;